module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq725-51bb86cea1fceb02c3df1c8e4d738801.jpg";